import { initDownloadActions } from '../js/modules/download.js';
import { accordion } from '../js/modules/accordion.js';
import { prepareDots } from '../js/modules/pageNavigation.js';
import { scrollItems } from '../js/modules/pageNavigation.js';
import floatingButton from '../js/modules/floating-button';
(function () {
    window.addEventListener('load', function () {
        initDownloadActions();
        accordion();
        prepareDots();
        scrollItems();
        new floatingButton();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules.js
// module id = 6
// module chunks = 0